var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.12 87.71",
    width: 35,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.52,4.92A4.91,4.91,0,1,1,26.61,0,4.91,4.91,0,0,1,31.52,4.92Z",
    style: {
      fill: "#0098d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.52,82.8a4.91,4.91,0,1,1-4.91-4.92A4.91,4.91,0,0,1,31.52,82.8Z",
    style: {
      fill: "#87bc49"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.37,67.09H8.21V20.61h6.16a3.37,3.37,0,0,0,0-6.73H4.12A4.19,4.19,0,0,0,0,18.06H0V69.62H0A4.17,4.17,0,0,0,4.12,73.8H14.37a3.36,3.36,0,1,0,0-6.72Z",
    style: {
      fill: "#0098d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.75,67.09h6.16V20.61H38.75a3.37,3.37,0,0,1,0-6.73H49a4.18,4.18,0,0,1,4.11,4.18h0V69.62h0A4.16,4.16,0,0,1,49,73.8H38.75a3.36,3.36,0,1,1,0-6.72Z",
    style: {
      fill: "#87bc49"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.36ed8153.svg";
export { ForwardRef as ReactComponent };